export const convertToFormDataShallow = (obj: Record<string, unknown>) => {
  const formData = new FormData();

  for (const [key, value] of Object.entries(obj)) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    formData.append(key, value as string | File);
  }

  return formData;
};
